import React from 'react';
import {FormattedMessage} from 'react-intl';

export const VoteCount = ({
    showZero = false,
    sm = false,
    totalVotes = 0
}) => {
    if (totalVotes > 0 || showZero) {
        return (
        <span className={`vote-count text-muted ${sm ? 'text-sm' : ''}`}>
            <FormattedMessage
                id="tripboards.votes"
                description="Number of votes"
                defaultMessage={`${totalVotes} votes`}
                values={{votesCount: totalVotes}}
            />
        </span>)
        ;
    }
    return null;
};

export default VoteCount;



// WEBPACK FOOTER //
// ./src/universal/tripboard/votes/vote-count.js